import React, { useContext, useEffect, useState } from "react"
import { DF_OT0012Context } from "../context"
import { Row } from "reactstrap"
import TableSimple from "../../../components/Dynamic/TableSimple"
import ModalIframePage from "../../../components/Common/ModalIframePage"
import axios from "axios"
import config from "../../../config"
import TranspaleStringToComponente from "../../../components/Dynamic/TranspaleStringToComponente"
import DragDropReorderTable from "../../../components/Dynamic/DragDropReorderTable"
import BizinBackend from "../../../helpers/bizin_helper"

const PROC_NAME = "FRONT_Workspace_DF_OT0012_Tabela_Grid_V16"

export default function GridBody() {
  const {
    paramsOnFilter,
    triggerOnFilter,
    setTriggerOnFilter,
    inputGlobalSearchValue,
    setFilteredData,
    userProfile,
    columns,
    setColumns,
    accessToken,
    csrfToken
  } = useContext(DF_OT0012Context)

  const [triggerType, setTriggerType] = useState('')
  const [openModalVisualization, setOpenModalVisualization] = useState(false)
  const [htmlContent, setHtmlContent] = useState('')

  const handleFetchVisualization = async (id) => {
    try {
      const resp = await axios.post(
        `${config.URL_SERVER}/gerar-visualizacao`,
        { parameters: { id_arquivo: id } },
        {
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": csrfToken,
          },
        },
      );
      const html =
        typeof resp.data === "string"
          ? resp.data
          : resp.data?.html || resp.data?.data || "";
      setHtmlContent(html || false);
    } catch (e) {
      setHtmlContent(false);
      console.error("Erro ao buscar visualização:", e);
    }
  };

  const handleTriggers = async (trigger) => {
    await handleFetchVisualization(trigger?.params);
    setOpenModalVisualization(true)
    setTriggerType(trigger)
  }

  const handleGetConfigColumns = async () => {
    try {
      const resp = await BizinBackend.executeProcedure(
        {
          1: userProfile.ID_Usuario,
          2: "DF_OT0012",
          3: null
        },
        'FRONT_Workspace_Obter_Layout_Grid',
        csrfToken,
        accessToken
      )
      setColumns(JSON.parse(resp[0]?.JSON_Configuracao_Colunas))
    } catch (error) {
      console.log("erro ao carregar FRONT_Workspace_DF_OT0012_Tabela_Grid_V16", error);
    }
  }

  useEffect(() => {
    handleGetConfigColumns()
  }, [])

  return (
    <React.Fragment>
      <Row>
        <TableSimple
          dataKey={"Protocolo"}
          procName={PROC_NAME}
          procParams={`[
            ${userProfile.ID_Usuario},
            "pt-BR",
            1,
            100,
            "AGEND",
            "<#Filtro_Data_Inicio#>",
            "<#Filtro_Data_Termino#>",
            "<#Filtro_ID_Empresa_Origem#>",
            "<#Filtro_ID_Empresa_Destino#>",
            "<#Filtro_Protocolo#>",
            "<#Filtro_Documento_Relacionado_Agendamento#>",
            "<#Filtro_Status#>",
            "<#Filtro_ID_Planta_Origem#>",
            "<#Filtro_ID_Planta_Destino#>",
            "<#Filtro_ID_Categoria#>",
            "<#Filtro_ID_Tipo_Agendamento#>"
          ]`}
          columnsList={columns}
          inputSearchValue={inputGlobalSearchValue}
          callbackTriggers={handleTriggers}
          enableDataSharing={true}
          onFilteredDataChange={setFilteredData}
          triggerOnFilter={triggerOnFilter}
          setTriggerOnFilter={setTriggerOnFilter}
          paramsOnFilter={paramsOnFilter}
          enableMinHeight={true}
        />

        <ModalIframePage
          openModal={openModalVisualization}
          onClosed={(isReloadPage) => {
            if (typeof isReloadPage === "boolean") setTriggerOnFilter(true)
            setOpenModalVisualization(false)
          }}
          htmlContent={htmlContent}
          triggerType={triggerType}
        />
      </Row>
    </React.Fragment>
  )
}
